import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuthenticated, selectInitLoading } from "../../redux";
import { hasValidTokens } from "../../utils/tokenHelper";
import PageLoader from "../ui/PageLoader/PageLoader";

/**
 * ProtectedRoute - Guards routes that require authentication
 * Redirects to login if user is not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const initLoading = useSelector(selectInitLoading);

  // Show loader while checking authentication status
  if (initLoading) {
    return <PageLoader />;
  }

  // Check both Redux state and localStorage tokens
  const hasTokens = hasValidTokens();
  const isUserAuthenticated = isAuthenticated || hasTokens;

  if (!isUserAuthenticated) {
    // Redirect to login, save the intended destination
    return (
      <Navigate
        to="/login"
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
